import React from "react";
import SupplierList from "../../Suppliers/SupplierList";

interface Props {
  storeId: string;
}

const StoreSuppliersTab: React.FC<Props> = ({ storeId }) => {
  return <SupplierList contextStoreId={storeId} />;
};

export default StoreSuppliersTab;
